"use client";

import createIcon from './util/createIcon';
export default createIcon('M13.28 12H18V14H13V21H11V14H6V12H10.72L5 3H7.37L12 10.29L16.63 3H19L13.28 12Z', 'CurrencyCny');